import { useState, useRef, useEffect } from "react";
import { ChevronDown, Check } from "lucide-react";

// CUSTOM SELECT COMPONENT
export function CustomSelect({
  value,
  onChange,
  options,
  className = "",
  menuClassName = "",
  direction = "down", // "down" | "up"
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const selectedOption = options.find((opt) => opt.value === value) || options[0];

  const positionClasses = direction === "up" 
    ? "bottom-full mb-1.5" 
    : "top-full mt-1.5";

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  
  return (
    <div ref={selectRef} className={`relative inline-block text-left ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center justify-between gap-2 bg-[#131110] border border-[#2e2720] text-stone-300 text-xs font-medium rounded-xl px-3 py-2 hover:border-amber-500/40 focus:outline-none transition min-w-[130px]"
      >
        <span className="truncate">{selectedOption?.label}</span>
        <ChevronDown
          className={`w-3.5 h-3.5 text-stone-500 transition-transform duration-200 shrink-0 ${
            isOpen ? "rotate-180 text-amber-400" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div
          className={`absolute left-0 top-full mt-1 z-50 min-w-full w-max max-h-60 overflow-y-auto bg-[#201c17] border border-[#2e2720] rounded-xl shadow-xl py-1 divide-y divide-[#2a241e] ${menuClassName}`}
        >
          {options.map((option) => {
            const isSelected = option.value === value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-xs font-medium text-left transition ${
                  isSelected
                    ? "bg-[#28221c] text-amber-400"
                    : "text-stone-300 hover:bg-[#25201a] hover:text-stone-100"
                }`}
              >
                <span>{option.label}</span>
                {isSelected && <Check className="w-3.5 h-3.5 text-amber-400 shrink-0" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}